/* ShowerNest – free shipping progress bars (top bar + cart boxes), with optional free gift step.
   Settings: section "Free shipping bar". */
(function () {
  if (window.__snFsbInit) return;
  window.__snFsbInit = true;
  var C = window.SN_FSB;
  if (!C) return;

  var TRUCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 7h11v9H3z"/><path d="M14 10h4l3 3v3h-7z"/><circle cx="7" cy="17.5" r="1.6"/><circle cx="17.5" cy="17.5" r="1.6"/></svg>';
  var GIFT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M5 12v8h14v-8M12 8v12"/><path d="M12 8c-1.5-3-5-3.5-5-1.2C7 8 9.5 8 12 8zM12 8c1.5-3 5-3.5 5-1.2C17 8 14.5 8 12 8z"/></svg>';
  var rate = (window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate)) || 1;
  var thresholdCents = Math.round(parseFloat(C.threshold || '49.99') * 100 * rate);
  var G = C.gift || {};
  var giftOn = !!(G.enabled && G.variantId && G.productId);
  var giftCents = Math.round(parseFloat(G.threshold || '119.99') * 100 * rate);
  var root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
  var busy = false;

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat('en-AU', { style: 'currency', currency: currency || 'AUD' }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }
  function fill(tpl, v) {
    return String(tpl || '')
      .split('[amount]').join(v.amount)
      .split('[threshold]').join(v.threshold)
      .split('[discount]').join(v.discount)
      .split('[items]').join(v.items)
      .split('[missing]').join(v.missing)
      .split('[gift_amount]').join(v.giftAmount)
      .split('[gift_threshold]').join(v.giftThreshold)
      .split('[gift_value]').join(v.giftValue);
  }
  function giftLines(cart) {
    return (cart.items || []).filter(function (i) { return String(i.product_id) === String(G.productId); });
  }

  // Keep the free gift in the cart only when the order qualifies.
  function syncGift(cart, total) {
    if (!giftOn || busy || !cart.items) return false;
    var lines = giftLines(cart);
    var qty = lines.reduce(function (s, l) { return s + l.quantity; }, 0);
    var req = null;
    if (total >= giftCents && qty === 0) {
      req = { url: 'cart/add.js', body: { items: [{ id: G.variantId, quantity: 1, properties: { _sn_gift: 'Free gift' } }] } };
    } else if (total >= giftCents && qty > 1) {
      req = { url: 'cart/change.js', body: { id: lines[0].key, quantity: 1 } };
    } else if (total < giftCents && qty > 0) {
      req = { url: 'cart/change.js', body: { id: lines[0].key, quantity: 0 } };
    }
    if (!req) return false;
    busy = true;
    fetch(root + req.url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(req.body) })
      .then(function () {
        busy = false;
        if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
        refresh();
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble) fetch(root + '?sections=cart-icon-bubble').then(function (r) { return r.json(); }).then(function (s) {
          if (s['cart-icon-bubble']) bubble.innerHTML = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html').querySelector('.shopify-section').innerHTML;
        }).catch(function () {});
      })
      .catch(function () { busy = false; });
    return true;
  }

  function render(cart) {
    var gl = giftOn ? giftLines(cart) : [];
    var giftPaid = gl.reduce(function (s, l) { return s + (l.final_line_price || 0); }, 0);
    var giftQty = gl.reduce(function (s, l) { return s + l.quantity; }, 0);
    var total = Math.max(0, cart.total_price - giftPaid);
    var count = cart.item_count - giftQty, cur = cart.currency;
    if (cart.items && syncGift(cart, total)) return;

    var left = Math.max(0, thresholdCents - total);
    var empty = count === 0;
    var done = !empty && total >= thresholdCents;
    var giftDone = giftOn && !empty && total >= giftCents;
    var pct = empty ? 0 : Math.min(100, (total / thresholdCents) * 100);
    var d = C.discount || {};
    var need = parseInt(d.minItems, 10) || 2;
    var v = {
      amount: money(left, cur),
      threshold: money(thresholdCents, cur),
      discount: d.label || '',
      items: need,
      missing: Math.max(0, need - count),
      giftAmount: money(Math.max(0, giftCents - total), cur),
      giftThreshold: money(giftCents, cur),
      giftValue: G.value || ''
    };
    var T = C.texts;

    document.querySelectorAll('[data-sn-fsb="top"]').forEach(function (el) {
      var msg;
      if (giftOn) msg = empty ? T.empty : giftDone ? T.giftDone : done ? T.giftNext : T.progress;
      else msg = empty ? T.empty : done ? T.done : T.progress;
      var w = giftOn && done ? Math.min(100, (total / giftCents) * 100) : pct;
      el.classList.toggle('is-empty', empty);
      el.classList.toggle('is-done', giftOn ? giftDone : done);
      el.querySelector('.sn-fsb__msg').innerHTML = fill(msg, v);
      el.querySelector('.sn-fsb__fill').style.width = w + '%';
    });

    document.querySelectorAll('[data-sn-fsb="box"]').forEach(function (el) {
      var html, width, dots;
      if (giftOn) {
        var p1 = Math.round((thresholdCents / giftCents) * 1000) / 10;
        width = empty ? 0 : Math.min(100, (total / giftCents) * 100);
        dots =
          '<span class="sn-fsb__dot' + (done ? ' is-on' : '') + '" style="left:' + p1 + '%">' + TRUCK + '<small>' + v.threshold + '</small></span>' +
          '<span class="sn-fsb__dot sn-fsb__dot--gift' + (giftDone ? ' is-on' : '') + '" style="left:100%">' + GIFT + '<small>' + v.giftThreshold + '</small></span>';
        html = fill(empty ? T.giftEmpty : giftDone ? T.giftDone : done ? T.giftNext : T.giftHint, v);
        el.classList.toggle('is-done', giftDone);
      } else if (d.enabled) {
        var two = count >= need;
        var msg = empty ? T.discEmpty : !done ? T.discHint : two ? T.discDone : T.discNext;
        width = empty ? 0 : done && two ? 100 : done ? 60 : Math.min(60, (total / thresholdCents) * 60);
        dots =
          '<span class="sn-fsb__dot' + (done ? ' is-on' : '') + '" style="left:60%">' + TRUCK + '<small>' + v.threshold + '</small></span>' +
          '<span class="sn-fsb__dot' + (done && two ? ' is-on' : '') + '" style="left:100%">%<small>' + need + ' items</small></span>';
        html = fill(msg, v);
        el.classList.toggle('is-done', done && two);
      } else {
        width = pct;
        dots = '<span class="sn-fsb__dot' + (done ? ' is-on' : '') + '" style="left:100%">' + TRUCK + '<small>' + v.threshold + '</small></span>';
        html = fill(empty ? T.cartEmpty : done ? T.cartDone : T.cartProgress, v);
        el.classList.toggle('is-done', done);
      }
      el.innerHTML =
        '<div class="sn-fsb__msg" role="status" aria-live="polite">' + html + '</div>' +
        '<div class="sn-fsb__track"><div class="sn-fsb__fill" style="width:' + width + '%"></div>' + dots + '</div>';
      el.hidden = false;
    });
  }

  var timer;
  function refresh() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(render)
        .catch(function () {});
    }, 150);
  }

  // Watch every cart change (theme forms, quantity buttons, bundle apps), whatever wraps fetch/XHR.
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  if ('PerformanceObserver' in window) {
    try {
      new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (e) {
          if (!busy && CART_RE.test(e.name.split('#')[0].replace(location.origin, ''))) refresh();
        });
      }).observe({ type: 'resource', buffered: false });
    } catch (e) {}
  }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

  function start() {
    render({ total_price: C.cart.total, item_count: C.cart.count, currency: C.cart.currency });
    refresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
